import React, { PropsWithChildren, useContext } from 'react';

import { AuthContext } from './AuthRouter';

export default function Authenticated({ children }: PropsWithChildren) {
  const { user } = useContext(AuthContext);

  return user ? <>{children}</> : null;
}
